var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    staticClass: "login",
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-content', {
    staticClass: "grey darken-1"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)], 1)], 1), _c('v-footer', {
    attrs: {
      "color": "primary",
      "app": ""
    }
  }, [_c('span', {
    staticClass: "white--text caption px-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$vuetify.t('$vuetify.app.copyright'))
    }
  }), _c('v-spacer'), _c('v-icon', {
    attrs: {
      "dark": ""
    },
    on: {
      "click": function click($event) {
        return _vm.reloadApp();
      }
    }
  }, [_vm._v("refresh")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }